export default __webpack_public_path__ + "static/chevron-styled-59f789a7ab60bdd3cf2f18b103461241.svg";